enum LicenseDialogFields {
	LICENSEE = "licensee",
	KEY = "key",
}

export default LicenseDialogFields;